/// <amd-module name="Environments/ProviderCreateDetails/Kubernetes/Stores/KubernetesResourceStore" />
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { KubernetesResourceActions, IGenericResourceValidationResult } from "Environments/ProviderCreateDetails/Kubernetes/Actions/KubernetesResourceActions";
import { EnvironmentResourceReference } from "DistributedTask/Client/Contracts/TaskAgent";
import { StoreBase, IStoreState } from "Environments/Flux/Store"

export interface IResourceStoreState extends IStoreState {
    resource: EnvironmentResourceReference;
    creationState: "InProgress" | "Succeeded" | "Failed" | "NotStarted";
    genericResourceValidationType: "Success" | "Warn" | "Error" | "None";
    genericResourceValidationMessage: string;
}

export class KubernetesResourceStore extends StoreBase {

    public static getKey(): string {
        return "kubernetes-resource-store";
    }

    public initialize(instanceId: string): void {
        super.initialize(instanceId);

        this._actionsHub = ActionsHubManager.GetActionsHub<KubernetesResourceActions>(KubernetesResourceActions, instanceId);
        this._actionsHub.addKubernetesResource.addListener(this._handleAddKubernetesResource);
        this._actionsHub.updateCreationState.addListener(this._onCreationStateChange);
        this._actionsHub.genericValidationResult.addListener(this._onGenericResourceValidation);

        this._state = {
            creationState: "NotStarted",
            genericResourceValidationType: "None",
            genericResourceValidationMessage: ""
        } as IResourceStoreState;
    }

    protected disposeInternal(): void {
        this._actionsHub.addKubernetesResource.removeListener(this._handleAddKubernetesResource);
        this._actionsHub.updateCreationState.removeListener(this._onCreationStateChange);
        this._actionsHub.genericValidationResult.removeListener(this._onGenericResourceValidation);
    }

    public getState(): IResourceStoreState {
        return this._state;
    }

    private _handleAddKubernetesResource = (resource: EnvironmentResourceReference) => {
        this._state.resource = resource;
        this._state.creationState = "Succeeded";
        this.emitChanged();
    }

    private _onCreationStateChange = (state: "InProgress" | "Succeeded" | "Failed" | "NotStarted") => {
        this._state.creationState = state;
        this.emitChanged();
    }

    private _onGenericResourceValidation = (payload: IGenericResourceValidationResult) => {
        this._state.genericResourceValidationType = payload.type;
        this._state.genericResourceValidationMessage = payload.message;
        this.emitChanged();
    }

    private _actionsHub: KubernetesResourceActions;
    private _state: IResourceStoreState = {} as IResourceStoreState;
}
